module.exports = "/assets/data/7d72e76108af065da417b65164015ec7-AB52.data.json";